import React from 'react';

import { Box } from '../Box';
import { InternalToggleButton } from '../ToggleButton/InternalToggleButton';
import { ToggleButtonGroupProps } from './interface';

export const ToggleButtonGroup = ({
  color,
  options,
  selected,
  size,
  onSelect,
}: ToggleButtonGroupProps) => {
  return (
    <Box>
      {options.map((option, i) => (
        <InternalToggleButton
          key={option.value}
          color={color}
          selected={option.value === selected?.value}
          onChange={() => onSelect(option)}
          variant="outlined"
          size={size}
          shape="square"
          grouped
          firstButton={i === 0}
          lastButton={i === options.length - 1}
        >
          {option.label}
        </InternalToggleButton>
      ))}
    </Box>
  );
};
